import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cache = null;

export default function useConsentTexts() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    if (!cache) cache = fetch(`${API}/consent/texts`).then((r) => r.json()).catch(() => (cache = null));
    let alive = true;
    Promise.resolve(cache).then((c) => alive && c && setCfg(c));
    return () => { alive = false; };
  }, []);
  return cfg;
}
